import InputResponsive1 from "../InputResponsive1";

import iconePesquisa from '../../assets/img/icone-pesquisa.svg'
import './styles.css'

const InputSearch = ({ totalNumber, checked, edited, notEdited, all, valueInput }) => {

    return (
        <div className='box-search'>
            <div id="bloco-pesquisa-turmas">
                <InputResponsive1  onChange={valueInput} />
                <div id="blocoImage">
                    <img src={iconePesquisa} alt="" />
                </div>
            </div>
            <div className='number-label-left'>
                <input type='radio' className='radio' name='add' checked={checked === 0?true:false} id="all" value={'all'} onChange={all} /> <label className='info-radio'>Todos</label>
                <input type='radio' className='radio' name='add' checked={checked === 1?true:false}id="yes" value={1} onChange={edited} /><label className='info-radio'>Editado</label>
                <input type='radio' className='radio' name='add' checked={checked === 2?true:false} id="no" value={0} onChange={notEdited} /> <label className='info-radio'>Não editado</label>
            </div>
        </div>
    )
}
export default InputSearch;